const range = (start, end) => new Array(end - start).fill(start).map((el, i) => start + i);

const shortMonth = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
];
const monthVisitData = shortMonth.splice(0,6).map(m => {

  return {
    'month': m,
    'Income Tax': Math.floor(Math.random() * 15000) + 2000,
    'Accounting': Math.floor(Math.random() * 10000) + 1000,
    'Business Startup': Math.floor(Math.random() * 3500) + 750
  };
});

const campaignData = [
  {
    value: 53502.43,
    name: 'Margem Livre'
  },
  {
    value: 38977.21,
    name: 'Refinanciamento'
  },
  {
    value: 23490.00,
    name: 'Portabilidade'
  },
  {
    value: 18780.22,
    name: 'Saque Complementar'
  }
];
const locationData = [
  {
    value: 65,
    name: 'Framingham'
  },
  {
    value: 35,
    name: 'Somerville'
  },
  {
    value: 15,
    name: 'Worcester'
  }
];

const StackMainData = [220, 182, 191, 234, 290, 330, 310, 123, 442, 321, 90, 149, 210, 122, 133, 334, 198, 123, 125, 220];
const StackData = StackMainData.map((item, key) => {
  return {
    'label': key + 'D',
    'max': 500,
    'sales': item,
  };
});   
const SinData = range(1, 12).map(i => {
  return {
    'cate': 'Cat' + i,
    'value': ((Math.sin(i / 5) * (i / 5 - 0.1) + i / 6) * 5)
  };
});


export {
  monthVisitData,
  campaignData,
  locationData,
  StackData,
  SinData,
};


// WEBPACK FOOTER //
// ./src/api/chart.js